import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import FormValidationError from '@/components/errors/FormValidationError';
import DictionariesDropdown from '@/datasets/dictionaries/components/DictionariesDropdown';
import { fetchRequestDictionaries, updateRequestDictionaries } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';
import fetch from '../hooks/fetch';

const RequestDictionariesDropdown = ({
  category,
  code,
  saveStatus,
  datasetCode,
  dictionaries,
  fetchData,
  readErrors,
  readStatus,
  updateDictionary,
}) => {
  fetch.useFetchRequestDictionaries(fetchData, category, code, datasetCode, readStatus);
  return (
    <FormValidationError htmlFor="dictionaries" labelId="access.dictionaries">
      <DictionariesDropdown
        byCode
        className="aridhia-request-dictionaries-dropdown"
        dictionaries={dictionaries}
        disabled={saveStatus === states.PENDING}
        errors={readErrors}
        id="dictionaries"
        message="access.dictionaries.placeholder"
        onChange={(e, { value }) => { updateDictionary(category, code, value); }}
        readStatus={readStatus}
      />
    </FormValidationError>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const safeSource = source || { code: null };

  return ({
    datasetCode: safeSource.code,
    dictionaries: safeSource.dictionaries || [],
    readErrors: safeSource.readErrors,
    readStatus: safeSource.readStatus,
    saveStatus: request.saveStatus,
  });
};

const mapDispatchToProps = {
  updateDictionary: updateRequestDictionaries,
  fetchData: fetchRequestDictionaries,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDictionariesDropdown);
